/**
 * Facebook Pixel Tracking Utility
 * Pixel ID: 2350123231896648
 * 
 * Standard Events: https://developers.facebook.com/docs/meta-pixel/reference
 */

// Check if fbq is available
const isFbqAvailable = () => typeof window !== 'undefined' && typeof window.fbq === 'function';

/**
 * Track a Lead event - for inquiry form submissions
 * @param {Object} params - Optional parameters
 * @param {string} params.content_name - Name/category of the lead
 * @param {string} params.content_category - Category
 * @param {number} params.value - Estimated value
 * @param {string} params.currency - Currency code (e.g., 'CAD')
 */
export const trackLead = (params = {}) => {
  if (isFbqAvailable()) {
    window.fbq('track', 'Lead', {
      content_name: params.content_name || 'Wedding Inquiry',
      content_category: params.content_category || 'Inquiry Form',
      value: params.value || 0,
      currency: params.currency || 'CAD',
      ...params
    });
    console.log('[FB Pixel] Lead event tracked', params);
  }
};

/**
 * Track a Contact event - for contact actions
 */
export const trackContact = () => {
  if (isFbqAvailable()) {
    window.fbq('track', 'Contact');
    console.log('[FB Pixel] Contact event tracked');
  }
};

/**
 * Track a ViewContent event - for viewing specific content
 * @param {Object} params - Content parameters
 * @param {string} params.content_name - Name of the content
 * @param {string} params.content_type - Type of content (e.g., 'collection', 'service')
 * @param {string} params.content_ids - Array of content IDs
 */
export const trackViewContent = (params = {}) => {
  if (isFbqAvailable()) {
    window.fbq('track', 'ViewContent', {
      content_type: params.content_type || 'page',
      ...params
    });
    console.log('[FB Pixel] ViewContent event tracked', params);
  }
};

/**
 * Track a Schedule event - for booking appointments
 */
export const trackSchedule = () => {
  if (isFbqAvailable()) {
    window.fbq('track', 'Schedule');
    console.log('[FB Pixel] Schedule event tracked');
  }
};

/**
 * Track a custom event
 * @param {string} eventName - Name of the custom event
 * @param {Object} params - Event parameters
 */
export const trackCustomEvent = (eventName, params = {}) => {
  if (isFbqAvailable()) {
    window.fbq('trackCustom', eventName, params);
    console.log(`[FB Pixel] Custom event "${eventName}" tracked`, params);
  }
};

/**
 * Track page view - useful for SPA navigation
 */
export const trackPageView = () => {
  if (isFbqAvailable()) {
    window.fbq('track', 'PageView');
    console.log('[FB Pixel] PageView event tracked');
  }
};

export default {
  trackLead,
  trackContact,
  trackViewContent,
  trackSchedule,
  trackCustomEvent,
  trackPageView
};
